(function() {
  'use strict';

  function init() {
    const drawer = document.querySelector('[data-rkx-cart-drawer]');
    if (!drawer) return;

    function openCart() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeCart() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function updateCartCount(count) {
      const trigger = document.querySelector('[data-rkx-cart-trigger]');
      if (!trigger) return;
      let badge = trigger.querySelector('[data-rkx-cart-count]');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'rkx-header__cart-count';
          badge.setAttribute('data-rkx-cart-count', '');
          trigger.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
    }

    async function refreshDrawer() {
      try {
        const url = window.location.pathname + (window.location.pathname === '/' ? '' : '') + '?section_id=rkx-cart-drawer';
        const resp = await fetch(url, { headers: { 'Accept': 'text/html' } });
        if (!resp.ok) throw new Error('Section fetch failed: ' + resp.status);
        const html = await resp.text();
        const temp = document.createElement('div');
        temp.innerHTML = html;
        const newPanel = temp.querySelector('.rkx-cart-drawer__panel');
        const currentPanel = drawer.querySelector('.rkx-cart-drawer__panel');
        if (newPanel && currentPanel) currentPanel.innerHTML = newPanel.innerHTML;

        const cartResp = await fetch('/cart.js');
        const cart = await cartResp.json();
        updateCartCount(cart.item_count);
      } catch (err) {
        console.error('[rkx-cart] refresh failed:', err);
      }
    }

    // Cart trigger (header icon)
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-rkx-cart-trigger]');
      if (trigger) {
        e.preventDefault();
        openCart();
        return;
      }
      const closeBtn = e.target.closest('[data-rkx-cart-close]');
      if (closeBtn) {
        e.preventDefault();
        closeCart();
        return;
      }
      if (e.target.matches('[data-rkx-cart-backdrop]')) {
        closeCart();
      }
    });

    // Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeCart();
    });

    // Intercept add-to-cart forms
    document.addEventListener('submit', async (e) => {
      const form = e.target;
      if (!form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();

      const button = form.querySelector('[type="submit"]');
      let originalText;
      if (button) {
        originalText = button.innerHTML;
        button.disabled = true;
        button.innerHTML = 'Adding\u2026';
      }

      try {
        const formData = new FormData(form);
        const resp = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        });
        if (!resp.ok) {
          const errData = await resp.json().catch(() => ({}));
          throw new Error(errData.description || errData.message || 'Could not add to cart');
        }
        await refreshDrawer();
        openCart();
      } catch (err) {
        console.error('[rkx-cart] add failed:', err);
        alert(err.message || 'Could not add to cart. Please try again.');
      } finally {
        if (button) {
          button.disabled = false;
          button.innerHTML = originalText;
        }
      }
    });

    // Qty steppers + remove (drawer AND cart page)
    document.addEventListener('click', async (e) => {
      const qtyBtn = e.target.closest('[data-rkx-cart-qty]');
      if (!qtyBtn) return;
      e.preventDefault();

      const line = parseInt(qtyBtn.dataset.line, 10);
      const action = qtyBtn.dataset.rkxCartQty;
      let newQty;

      if (action === 'remove') {
        newQty = 0;
      } else {
        const stepper = qtyBtn.parentElement;
        const qtySpan = stepper.querySelector('span');
        let currentQty = parseInt(qtySpan ? qtySpan.textContent : '1', 10);
        if (isNaN(currentQty)) currentQty = 1;
        newQty = action === 'inc' ? currentQty + 1 : Math.max(0, currentQty - 1);
      }

      try {
        const resp = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line, quantity: newQty })
        });
        if (!resp.ok) throw new Error('Cart change failed');
        // Refresh drawer
        await refreshDrawer();
        // If on cart page, reload to update the page items
        if (window.location.pathname === '/cart') {
          window.location.reload();
        }
      } catch (err) {
        console.error('[rkx-cart] change failed:', err);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
